/* Text with icons: the shared slideshow drives the one-at-a-time phone layout,
   but from 700px up every item is shown, so slides must stay interactive. */
customElements.whenDefined('av-slideshow').then(() => {
  if (customElements.get('av-icon-slides')) return;
  const { Slideshow } = window.Theme;

  class IconSlides extends Slideshow {
    connectedCallback() {
      this.wide = window.matchMedia('(min-width: 700px)');
      super.connectedCallback();
      this.onWidthChange = () => this.syncInert();
      this.wide.addEventListener('change', this.onWidthChange);
      this.syncInert();
    }

    disconnectedCallback() {
      super.disconnectedCallback();
      this.wide?.removeEventListener('change', this.onWidthChange);
    }

    select(index, instant) {
      if (this.wide?.matches) return;
      super.select(index, instant);
      this.syncInert();
    }

    syncInert() {
      (this.slides || []).forEach((slide, i) => slide.toggleAttribute('inert', !this.wide.matches && i !== this.index));
    }
  }

  customElements.define('av-icon-slides', IconSlides);
});
